"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.ifPromiseUnresolved = ifPromiseUnresolved;
/**
 * ifPromiseUnresolved
 *
 * Calls the callback if the promise is not resolved within the timeoutMs.
 */

function ifPromiseUnresolved(promise, timeoutMs, callback) {
  var resolved = false;
  promise.then(function () {
    resolved = true;
  });
  setTimeout(function () {
    if (!resolved) callback();
  }, timeoutMs);
}